<mat-form-field
  class="w-100"
  [ngClass]="{ 'read-only': readOnly || currentConfig?.readOnly }"
  [formGroup]="parentFormGroup"
  [title]="parentFormGroup?.get(currentConfig.property)?.value || ''"
  [floatLabel]="currentConfig?.tooltipConfig?.tooltipDesc ? 'always' : 'auto'"
  [hintLabel]="currentConfig.hintLabel"
>
  <ng-template
    raMatLabelTooltip
    [tooltipConfig]="currentConfig?.tooltipConfig"
  ></ng-template>
  <mat-label>{{ currentConfig.displayText }}</mat-label>
  @if (currentConfig.uiControlType === UiControlType.Number) {
    <input
      type="number"
      [disabled]="currentConfig?.readOnly"
      matInput
      [formControlName]="currentConfig.property"
      (change)="onValueChanged()"
    />
  }
  @if (currentConfig.uiControlType === UiControlType.Text) {
    <input
      type="text"
      [disabled]="currentConfig?.readOnly"
      matInput
      [formControlName]="currentConfig.property"
      (change)="onValueChanged()"
    />
  }
  @if (currentConfig.uiControlType === UiControlType.TextArea) {
    <textarea
      [disabled]="currentConfig?.readOnly"
      matInput
      [formControlName]="currentConfig.property"
      (change)="onValueChanged()"
    >
    </textarea>
  }
  @if (currentConfig.uiControlType === UiControlType.Date) {
    <input
      type="date"
      [disabled]="currentConfig?.readOnly"
      matInput
      [formControlName]="currentConfig.property"
      (change)="onValueChanged()"
    />
  }
  <mat-error>
    {{
      currentConfig?.errorMessages?.[
        keys(parentFormGroup?.get(currentConfig.property)?.errors)?.[0]
      ] || "Please review the field"
    }}
  </mat-error>
</mat-form-field>
